import { Col } from 'react-bootstrap'
import FileBlock from 'components/ui/forms/field/awesomeFileInput/components/FileBlock'
import { UploadFileStatusEnum } from 'enum/uploadFile-status.enum'
import { BlockMultimediaContent } from 'store/states/lessons.state'
import { downloadFile } from 'helpers/downloadFile.helper'
import styles from './DownloadFile.module.scss'

interface DownloadFileProps {
  dataMultimedia: BlockMultimediaContent
}
export function DownloadFile({ dataMultimedia }: DownloadFileProps) {
  const { url } = dataMultimedia
  const { fileData } = dataMultimedia
  if (!fileData?.id) return null

  const {
    metadata: { size, filename },
    id,
  } = fileData

  return (
    <Col xs={12} md={10} lg={8} xl={7} className={`${styles.blockContainer}`}>
      <FileBlock
        data={{
          id,
          name: filename,
          size,
          progress: 0,
          status: UploadFileStatusEnum.completed,
        }}
        disabled
        onDownload={() => downloadFile(url, filename)}
      />
    </Col>
  )
}
